import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { OrganizationMetadataCompartments, organizationMetadataStorageKey } from '..';

export class OrganizationMetadataListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(organizationMetadataStorageKey)
    private readonly cache: DataCache<OrganizationMetadataCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('metadata');
        } else {
          this.cache.reset('metadata');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
